import AuthenticationService from "../services/AuthenticationService";
import {Country, MenuEntry, MenuEntryBase} from "@ui-components/AppNavigation/types";
import {evaluateRule} from "@ui-components/AppNavigation/utilities";

/**
 * Function to filter the routes based on the user's roles/scopes and current country
 *
 * @param routes - The routes to filter
 * @param countryCode - The current country code
 *
 * @returns The filtered routes
 */
const filterRoutesByRoutes = (routes: MenuEntryBase[], countryCode: Country) => {

  // Retrieve user's data
  const user = AuthenticationService.getUserData();
  const userRoles: string[] = AuthenticationService.getUserRoles();
  const userScopes: string[] = [
    ...AuthenticationService.getUserScopes(),
    ...(AuthenticationService.getAccountUserScopes() ?? []),
  ];

  return routes
    .filter(({roles: entryRoles, scopes: entryScopes}) => {

      // If the current route has no restrictions, automatically allow it
      // TODO check if this legacy behavior is correct
      if (!user)
        return true;

      // Evaluate the roles rule first (if any)
      if (!!entryRoles && !evaluateRule(entryRoles, userRoles, countryCode))
        return false;

      // Evaluate the scopes rule (if any)
      if (!!entryScopes && !evaluateRule(entryScopes, userScopes, countryCode))
        return false;

      return true;
    })
    .map((entry): MenuEntry => {
      // If the current route has a dropdown, filter its sub-routes as well
      if (!("dropdown" in entry))
        return entry as MenuEntry;
      // At this point we can assume that the entry has a dropdown (i.e. it's a MenuEntry)
      const currentEntry = entry as MenuEntry;
      return {
        ...currentEntry,
        dropdown: filterRoutesByRoutes(currentEntry.dropdown!, countryCode),
      } as MenuEntry;
    })
    // Remove empty dropdowns (i.e. items that have a dropdown whose length is 0 after filtering)
    .filter(({dropdown}) => !dropdown || dropdown.length > 0);
};

export default filterRoutesByRoutes;
